module.exports = __webpack_public_path__ + "static/flags/GE-714976707457a4945aa749862a403625.gif";